
import store from '../../store'
import { showLoading, hideLoading} from 'react-redux-loading-bar'

const LoadingBar = (val) => {
  if (val) {
    store.dispatch(showLoading())
  }else{
    store.dispatch(hideLoading())
  }
}

export default LoadingBar